
/**
 * Image optimization utilities
 */

// Intersection Observer for lazy loading
export const setupLazyLoading = () => {
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll<HTMLImageElement>('img[data-src]');
    
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target as HTMLImageElement;
          img.src = img.dataset.src || '';
          img.removeAttribute('data-src');
          imageObserver.unobserve(img);
        }
      });
    }, {
      rootMargin: '100px',
    });

    lazyImages.forEach((img) => {
      imageObserver.observe(img);
    });
  } else {
    // Fallback for browsers without Intersection Observer
    const lazyImages = document.querySelectorAll<HTMLImageElement>('img[data-src]');
    lazyImages.forEach((img) => {
      img.src = img.dataset.src || '';
      img.removeAttribute('data-src');
    });
  }
};

// Add responsive image sizes attribute
export const getResponsiveImageAttributes = (
  baseWidth: number,
  baseHeight?: number
): { sizes: string; loading: "lazy" } => {
  return {
    sizes: `
      (max-width: 640px) 100vw,
      (max-width: 768px) 75vw,
      (max-width: 1024px) 50vw,
      33vw
    `,
    loading: "lazy"
  };
};

// Function to use next-gen formats if supported
export const getOptimizedImageSource = (imagePath: string): string => {
  // In a real implementation, you would check for WebP or AVIF support
  // For this implementation we'll just return the original path
  // In production, you would serve .webp or .avif versions
  return imagePath;
};
